import React from "react";
import { motion } from "framer-motion";
import {
  FaShieldAlt,
  FaEye,
  FaRuler,
  FaFlask,
  FaCheckCircle,
  FaAward,
  FaCertificate,
  FaTools,
  FaMicroscope,
  FaClipboardCheck,
} from "react-icons/fa";
import dexterImage5 from "../../../assets/dexter-images/dexter-5.jpg";
// import dexterImage6 from "../../../assets/dexter-images/dexter-6.jpg";

function QualityTesting() {
  return (
    <div className="service-page quality-page">
      <motion.div
        className="service-hero"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <div className="hero-content">
            <h1>Quality Testing & Inspection</h1>
            <p>
              Comprehensive Quality Assurance with Advanced Testing Equipment
            </p>
          </div>
        </div>
      </motion.div>

      <motion.div
        className="service-content"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        <div className="container">
          {/* Hero Section with Image */}
          <div className="service-hero-section">
            <div className="hero-text">
              <h2>Quality Assurance Excellence</h2>
              <p>
                DexteR Technology upholds the highest standards of quality
                through rigorous testing and meticulous inspection processes.
                Our advanced quality control system ensures that every component
                meets precise specifications, achieving tolerances as fine as 10
                microns to guarantee unmatched accuracy and reliability.
              </p>
              <div className="hero-features">
                <div className="feature-item">
                  <FaCheckCircle className="feature-icon" />
                  <span>10 Micron Precision</span>
                </div>
                <div className="feature-item">
                  <FaCheckCircle className="feature-icon" />
                  <span>Advanced Testing Equipment</span>
                </div>
                <div className="feature-item">
                  <FaCheckCircle className="feature-icon" />
                  <span>Certified Processes</span>
                </div>
              </div>
            </div>
            <div className="hero-image">
              <img src={dexterImage5} alt="Quality Testing and Inspection" />
            </div>
          </div>

          {/* Quality Control Process */}
          <div className="capabilities-section">
            <h2>Our Quality Control Process</h2>
            <div className="capabilities-grid">
              <motion.div
                className="capability-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                viewport={{ once: true }}
                whileHover={{ y: -10 }}
              >
                <div className="card-icon">
                  <FaEye />
                </div>
                <h3>Visual Inspection</h3>
                <p>
                  Comprehensive visual examination of components for surface
                  defects, finish quality, and dimensional accuracy
                </p>
                <ul>
                  <li>Surface finish inspection</li>
                  <li>Dimensional verification</li>
                  <li>Defect identification</li>
                  <li>Appearance standards</li>
                </ul>
              </motion.div>

              <motion.div
                className="capability-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
                whileHover={{ y: -10 }}
              >
                <div className="card-icon">
                  <FaRuler />
                </div>
                <h3>Dimensional Testing</h3>
                <p>
                  Precise measurement of critical dimensions using advanced
                  metrology equipment and calibrated instruments
                </p>
                <ul>
                  <li>Precision measurement</li>
                  <li>Tolerance verification</li>
                  <li>Calibrated instruments</li>
                  <li>Statistical analysis</li>
                </ul>
              </motion.div>

              <motion.div
                className="capability-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.3 }}
                viewport={{ once: true }}
                whileHover={{ y: -10 }}
              >
                <div className="card-icon">
                  <FaFlask />
                </div>
                <h3>Material Analysis</h3>
                <p>
                  Comprehensive material testing including composition analysis,
                  hardness testing, and material verification
                </p>
                <ul>
                  <li>Material composition</li>
                  <li>Hardness testing</li>
                  <li>Material verification</li>
                  <li>Quality certification</li>
                </ul>
              </motion.div>

              <motion.div
                className="capability-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
                whileHover={{ y: -10 }}
              >
                <div className="card-icon">
                  <FaShieldAlt />
                </div>
                <h3>Performance Testing</h3>
                <p>
                  Functional testing of components under various conditions to
                  ensure reliability and performance standards
                </p>
                <ul>
                  <li>Functional testing</li>
                  <li>Load testing</li>
                  <li>Durability testing</li>
                  <li>Performance validation</li>
                </ul>
              </motion.div>
            </div>
          </div>

          {/* <div className="process-image-section">
            <motion.div
              className="process-image"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <img src={dexterImage6} alt="Quality Control Process" />
              <div className="image-overlay">
                <div className="overlay-content">
                  <h3>Advanced Quality Control</h3>
                  <p>
                    Comprehensive testing and inspection with precision
                    equipment
                  </p>
                </div>
              </div>
            </motion.div>
          </div> */}

          {/* Inspection Equipment */}
          <div className="materials-section">
            <h2>Advanced Inspection Equipment</h2>
            <div className="materials-grid">
              <motion.div
                className="material-card"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="material-icon">
                  <FaMicroscope />
                </div>
                <h3>Precision Microscopes</h3>
                <p>
                  High-magnification microscopes for detailed surface inspection
                  and defect analysis
                </p>
              </motion.div>

              <motion.div
                className="material-card"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="material-icon">
                  <FaRuler />
                </div>
                <h3>Digital Calipers</h3>
                <p>
                  High-precision digital measuring instruments for accurate
                  dimensional verification
                </p>
              </motion.div>

              <motion.div
                className="material-card"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.3 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="material-icon">
                  <FaClipboardCheck />
                </div>
                <h3>Quality Documentation</h3>
                <p>
                  Comprehensive documentation system for quality records and
                  traceability
                </p>
              </motion.div>

              <motion.div
                className="material-card"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="material-icon">
                  <FaTools />
                </div>
                <h3>Specialized Tools</h3>
                <p>
                  Industry-specific testing tools and equipment for specialized
                  applications
                </p>
              </motion.div>

              <motion.div
                className="material-card"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.5 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="material-icon">
                  <FaCertificate />
                </div>
                <h3>Certified Standards</h3>
                <p>
                  Calibrated reference standards ensuring measurement accuracy
                  and traceability
                </p>
              </motion.div>

              <motion.div
                className="material-card"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.6 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="material-icon">
                  <FaAward />
                </div>
                <h3>Quality Certifications</h3>
                <p>
                  Industry-recognized quality certifications and compliance
                  standards
                </p>
              </motion.div>
            </div>
          </div>

          {/* Quality Parameters */}
          <div className="specs-section">
            <h2>Quality Control Parameters</h2>
            <div className="specs-grid">
              <motion.div
                className="spec-item"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                viewport={{ once: true }}
              >
                <h3>Dimensional Accuracy</h3>
                <p>
                  Precision measurements with tolerances up to 10 microns for
                  critical applications
                </p>
              </motion.div>

              <motion.div
                className="spec-item"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
              >
                <h3>Surface Finish</h3>
                <p>
                  Comprehensive surface finish analysis and quality verification
                  processes
                </p>
              </motion.div>

              <motion.div
                className="spec-item"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.3 }}
                viewport={{ once: true }}
              >
                <h3>Material Verification</h3>
                <p>
                  Material composition analysis and hardness testing for quality
                  assurance
                </p>
              </motion.div>

              <motion.div
                className="spec-item"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
              >
                <h3>Functional Testing</h3>
                <p>
                  Performance testing under various conditions to ensure
                  reliability standards
                </p>
              </motion.div>
            </div>
          </div>

          {/* Certifications */}
          {/* <div className="why-choose-section">
            <h2>Certifications and Standards</h2>
            <div className="benefits-grid">
              <motion.div
                className="benefit-item"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                viewport={{ once: true }}
              >
                <FaCheckCircle className="benefit-icon" />
                <h3>ISO 9001 Certified</h3>
                <p>
                  Quality management system certified to international standards
                </p>
              </motion.div>

              <motion.div
                className="benefit-item"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
              >
                <FaCheckCircle className="benefit-icon" />
                <h3>Industry Standards</h3>
                <p>
                  Compliance with industry-specific quality standards and
                  requirements
                </p>
              </motion.div>

              <motion.div
                className="benefit-item"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.3 }}
                viewport={{ once: true }}
              >
                <FaCheckCircle className="benefit-icon" />
                <h3>Traceability</h3>
                <p>
                  Complete traceability of quality control processes and
                  measurements
                </p>
              </motion.div>

              <motion.div
                className="benefit-item"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
              >
                <FaCheckCircle className="benefit-icon" />
                <h3>Continuous Improvement</h3>
                <p>
                  Ongoing quality improvement processes and regular system
                  audits
                </p>
              </motion.div>
            </div>
          </div> */}

          {/* Process Image */}
        </div>
      </motion.div>
    </div>
  );
}

export default QualityTesting;
